import { NetworkClient, useClassFactory, useNetworkService } from "@pasta/box-v2";
import { type AgentsDirectoryAutocompleteItem } from "../dto/agents-directory.dto";

export class AgentsDirectoryApi {
  protected readonly baseEndpoint = "/agentdex";

  protected get network(): NetworkClient {
    return useNetworkService();
  }

  async autocomplete(pattern: string): Promise<AgentsDirectoryAutocompleteItem[]> {
    const response = await this.network.get(`${this.baseEndpoint}`, {
      pattern,
    });
    return response.data;
  }
}

export const [agentsDirectoryApiToken, useAgentsDirectoryApi] = useClassFactory(AgentsDirectoryApi);
